import React from "react";
import { Col, Table } from "antd";
import "./table.css";

const AntDesignTable = ({ style, columns, data, onRow, props, className, loading }) => {
  return (
    <Col className="admin-table-scroll" span={24}>
      <Table
        style={style}
        columns={columns}
        pagination={false}
        dataSource={data}
        onRow={onRow}
        className={className}
        loading={loading}
        {...props}
      />
    </Col>
  );
};

export default AntDesignTable;
